const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "FileName",
    label: "文件名",
    columnwidth: 280,
  },
  {
    prop: "ContractStatusName",
    label: "文件状态",
    columnwidth: 160,
  },
  {
    prop: "UploadTime",
    label: "上传日期",
    columnwidth: 189,
  },
  {
    prop: "czAll",
    label: "操作",
    columnwidth: 240,

  },
];
export default headerData;
